import { createWebHistory, createRouter } from "vue-router";
import routerUser from "@/routes/user.js";
import routerLogin from "@/routes/login.js";
import routerTest from "@/routes/test.js";
import routerAdmin from "@/routes/admin.js";

const routes = [
	{
		path: "/",
		component: () => import("@/views/main/Index"),
		meta: { layout: "User",}
	},
	...routerUser,
	...routerLogin,
	...routerTest,
	...routerAdmin
];

export const router = createRouter({
	history: createWebHistory(),
	routes,
});
